var TablaAspectos = function(el, datos, total, callback) {
  var debug = false;

  var altoIcono = 55;
  var paddingIcono = 10;

  var altoVisualizacion = 0;
  var alturaRenglon = altoIcono + 2 * paddingIcono;

  var auxMedidas = {
    top: 20,
    right: 20,
    bottom: 20,
    left: 20
  };

  (function() {
    datos.opciones = _.filter(datos.opciones, function(d) {
      return d.positivos.length > 0 || d.negativos.length > 0;
    });
    datos.opciones.sort(ordenaOpcion);

    var config = new Config(0, auxMedidas);
    var contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      var tabla = config.getTabla();
      var svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", "0 0 " + config.getAncho() + " " + 0);
      var textos = svg.selectAll("text").data(datos.opciones, function(d) {
        return d.opcion;
      });
      altoVisualizacion = alturaRenglon * (datos.opciones.length + 1);
      var margin = config.getMargin();
      var gMargin = config.getGMargin();
      altoVisualizacion +=
        margin.top + margin.bottom + gMargin.top + gMargin.bottom;
      svg.remove();
    }
  })();

  var config = new Config(altoVisualizacion, auxMedidas);

  var margin = config.getMargin();
  var medidas = config.getMedidas();

  var gMargin = config.getGMargin();
  var gMedidas = config.getGMedidas();

  var estilos = config.getEstilos();

  var contenedor = null;
  var svg = null;
  var gGrafica = null;

  var renglones = null;

  function setup() {
    contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      el.data("visualizacion", true);
      contenedor.selectAll("svg").remove();
      svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr(
          "viewBox",
          "0 0 " +
            (medidas.ancho + margin.left + margin.right) +
            " " +
            (medidas.alto + margin.top + margin.bottom)
        );

      el.attr("data-setup", true);

      if (debug === true) {
        svg
          .append("rect")
          .attr("fill", "yellow")
          .attr("opacity", 0.5)
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", medidas.ancho + margin.left + margin.right)
          .attr("height", medidas.alto + margin.top + margin.bottom);
      }

      svg = svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      if (debug === true) {
        svg
          .attr("class", "svg")
          .append("rect")
          .attr("width", medidas.ancho + (margin.right - margin.left))
          .attr("height", medidas.alto)
          .attr("fill", "blue")
          .attr("opacity", 0.5);
      }

      gGrafica = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + gMargin.left + "," + gMargin.top + ")"
        );

      if (debug === true) {
        gGrafica
          .attr("class", "gGrafica")
          .append("rect")
          .attr("width", gMedidas.ancho)
          .attr("height", gMedidas.alto)
          .attr("fill", "red")
          .attr("opacity", 0.5);
      }
      main();
    }
  }

  function main() {
    setLeyendas();
    setTabla();
    funciones.generaTooltips(gGrafica.selectAll("path.transporte"));
    el.removeClass("espera");
    iniciar();
  }

  function revisaScroll() {
    if (el.visible(true) === true) {
      iniciar();
      $(window).off("scroll", revisaScroll);
    }
  }

  function iniciar() {
    actualizaTabla();
    callback(null, true);
  }

  function setTabla() {
    var tabla = config.getTablaAspectos();
    var transportes = config.getTransportes();
    var gCabecera = gGrafica.append("g").attr("class", "cabecera");
    var gCuerpo = gGrafica
      .append("g")
      .attr("class", "cuerpo")
      .attr("transform", "translate(0," + alturaRenglon + ")");

    renglones = gCuerpo
      .selectAll("g.renglon")
      .data(datos.opciones, function(d) {
        return d.opcion;
      })
      .enter()
      .append("g")
      .attr("class", "renglon")
      .attr("fill", function(d, i) {
        return i % 2 === 0 ? tabla.fondo : "transparent";
      })
      .attr("transform", function(d, i) {
        return "translate(0," + alturaRenglon * i + ")";
      });

    var x = gMedidas.ancho / 3;

    gCabecera
      .append("text")
      .attr("y", alturaRenglon / 2)
      .attr("x", x / 2)
      .style(tabla.estiloCabecera)
      .text("Medio de transporte principal");

    gCabecera
      .append("text")
      .attr("y", alturaRenglon / 2)
      .attr("x", (x * 3) / 2)
      .style(tabla.estiloCabecera)
      .text("Aspectos positivos");

    gCabecera
      .append("text")
      .attr("y", alturaRenglon / 2)
      .attr("x", (x * 5) / 2)
      .style(tabla.estiloCabecera)
      .text("Aspectos negativos");

    gGrafica
      .append("line")
      .attr("x1", x)
      .attr("y1", 0)
      .attr("x2", x)
      .attr("y2", gMedidas.alto)
      .style(tabla.estiloSeparador);

    gGrafica
      .append("line")
      .attr("x1", 2 * x)
      .attr("y1", 0)
      .attr("x2", 2 * x)
      .attr("y2", gMedidas.alto)
      .style(tabla.estiloSeparador);

    renglones
      .append("rect")
      .attr("x", 0)
      .attr("y", 0)
      .attr("height", alturaRenglon)
      .attr("width", gMedidas.ancho)
      .attr("opacity", function(d, i) {
        return i % 2 === 0 ? 0.3 : 1;
      });

    renglones
      .append("path")
      .attr("class", "transporte")
      .attr("d", function(d) {
        return d.ruta;
      })
      .attr("transform", function(d) {
        var caja = this.getBBox();
        d.caja = caja;
        d.caja.scale =
          caja.height < altoIcono
            ? altoIcono / caja.height
            : caja.height / altoIcono;
        d.coords = {};
        d.coords.x = -d.caja.x * d.caja.scale;
        d.coords.y = -d.caja.y * d.caja.scale;
        d.coords.x += (x - d.caja.width * d.caja.scale) / 2;
        d.coords.y += (alturaRenglon - d.caja.height * d.caja.scale) / 2;
        return (
          "translate(" +
          d.coords.x +
          "," +
          d.coords.y +
          ")scale(" +
          d.caja.scale +
          ")"
        );
      })
      .attr("fill", transportes.fondo);

    renglones
      .append("text")
      .attr("opacity", 0)
      .attr("x", x + tabla.paddingAspectosX)
      .attr("y", tabla.paddingAspectosY)
      .style(tabla.estiloRenglon)
      .each(function(d) {
        var txt = d3.select(this);
        _.each(d.positivos, function(p, i) {
          txt
            .append("tspan")
            .attr("x", x + tabla.paddingAspectosX)
            .attr("dy", "1.1em")
            .text(p);
        });
      });

    renglones
      .append("text")
      .attr("opacity", 0)
      .attr("x", 2 * x + tabla.paddingAspectosX)
      .attr("y", tabla.paddingAspectosY)
      .style(tabla.estiloRenglon)
      .each(function(d) {
        var txt = d3.select(this);
        _.each(d.negativos, function(p, i) {
          txt
            .append("tspan")
            .attr("x", 2 * x + tabla.paddingAspectosX)
            .attr("dy", "1.1em")
            .text(p);
        });
      });

    renglones
      .append("line")
      .attr("x1", 0)
      .attr("y1", 0)
      .attr("x2", gMedidas.ancho)
      .attr("y2", 0)
      .style(tabla.estiloSeparador);
  }

  function actualizaTabla() {
    renglones
      .selectAll("text")
      .attr("opacity", 0)
      .transition()
      .duration(800)
      .attr("opacity", 1);
  }

  function setLeyendas() {}

  function ordenaOpcion(a, b) {
    var aTxt = a.etiqueta.toLowerCase();
    var bTxt = b.etiqueta.toLowerCase();
    if (aTxt < bTxt) {
      return -1;
    }
    if (aTxt > bTxt) {
      return 1;
    }
    return 0;
  }

  setup();
};
